var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('HeaderComponent'),_c('SidebarComponent'),_c('div',{class:[_vm.footerTypeIs,_vm.contentClass],attrs:{"id":"main-content"}},[_vm._t("default")],2),_c('AuthFooterComponent',{attrs:{"footerType":_vm.footerTypeIs}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }